import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { DiagnosistableDataType, DiagnosisType } from "../Types/TableType";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { getDiagnosisData } from "../../../EMR/services";
import { Box, Divider, IconButton, Typography, Paper } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import usePopup from "../../../hooks/usePopup";
import PatientDiagnosis from "../../../EMR/components/Diagnosis";
import {
  verificationContext,
  ContextType,
} from "../context/VerificationContext";

export default function DaignosisTable() {
  const [tableData, setTableData] = useState<DiagnosistableDataType>({
    totalCount: 0,
    items: [],
  });

  const { mutate: getDiagnosis, isLoading: diagnosisLoading } = useMutation(
    getDiagnosisData,
    {
      onSuccess: (data: any) => {
        setTableData((prev) => ({ ...prev, items: data.response }));
      },
    }
  );

  const { searchData } = useContext(verificationContext) as ContextType;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (searchData?.encounter?.encounterId) {
      getDiagnosis(searchData?.encounter?.encounterId);
    }
  }, [searchData?.encounter?.encounterId]);

  const closePopUp = () => {
    getDiagnosis(searchData?.encounter?.encounterId as number);
    setOpen(false);
  };

  const { CustomModal } = usePopup();

  return (
    <>
      <CustomModal
        title="Diagnosis"
        open={open}
        setOpen={setOpen}
        handleClose={() => closePopUp()}
      >
        <div className="w-[50vw]">
          <PatientDiagnosis />
        </div>
      </CustomModal>

      <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Diagnosis
          </Typography>
          <IconButton
            onClick={() => {
              setOpen(true);
            }}
            edge="end"
          >
            <EditNoteIcon color="primary" />
          </IconButton>
        </Box>
        <Divider sx={{ marginBottom: 2 }} />

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  ICD Code
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                >
                  Description
                </TableCell>
              </TableRow>
            </TableHead>

            <CustomTableBody
              isData={tableData?.items?.length > 0}
              dataLoading={diagnosisLoading}
              totalSpan={{ row: 5, col: 4 }}
              alert={"No Records Found"}
            >
              {tableData?.items?.map((row: DiagnosisType, index: number) => (
                <TableRow
                  key={`${row.icdCode}${index}tablebody`}
                  sx={{
                    "&:hover": { backgroundColor: "#f9f9f9" },
                    "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  }}
                >
                  <TableCell align="center">{row.type}</TableCell>
                  <TableCell align="center">{row.icdCode}</TableCell>
                  <TableCell align="center">{row.icdName}</TableCell>
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}
